import lodash from 'lodash';
import { composeReducers } from 'common/util/composeReducers';
import {
    LOAD_ROLE_PERMISSIONS,
    LOADING_ROLE_PERMISSIONS,
} from '../actions/permissions';
import { permissionSort } from '../utils';
import { doaFeatureAccess } from 'common/features/predicates';
import { userDefaultInstitutionIdSelector } from 'common/selectors';
import { features } from 'common/permissions/studyPredicates';

const permissionRolesOrder = [
    {
        name: 'Admin',
        tooltip: 'A user who has the ability to Create Studies for that institution, and the ability to edit permissions for key study personnel.',
    },
    {
        name: 'Team Member',
        tooltip: 'A user who has been assigned a specific role on the Study and is on the delegation log.',
    },
    {
        name: 'Viewer',
        tooltip: 'A user who does not have a specific role on the Study but needs to access the Study to view documents, download documents, etc.',
    },
    {
        name: 'Monitor',
        tooltip: 'A user who needs to be able to view and export documents and events for the Study.',
    },
];

export function getRolesPermissions(state, action) {
    if (!action || action.type !== LOAD_ROLE_PERMISSIONS) {
        return state;
    }
    const { eregPermissions, permissionRoles } = action.payload;

    const columns = [{
        title: 'Action',
        field: 'displayName',
        isEditable: false,
        tooltip: <span>Please follow this link to learn more about the key Study actions that you can assign to your users:
            <a href="https://complion.zendesk.com/hc/en-us" target="_blank" style={{ color: 'white', marginLeft: '5px' }}>https://complion.zendesk.com/hc/en-us</a></span>,
    }];

    const institutionId = userDefaultInstitutionIdSelector(state);
    const canManageDoA = doaFeatureAccess(state, institutionId);

    permissionRolesOrder.forEach(orderedRole => {
        const permissionRole = permissionRoles.find(role => role.name === orderedRole.name);
        if (permissionRole) {
            const { name, isSystem } = permissionRole;
            columns.push({
                id: permissionRole.id,
                title: name,
                field: name,
                isEditable: lodash.isNull(isSystem) ? false : !isSystem,
                ...(orderedRole.tooltip && { tooltip: orderedRole.tooltip }),
            });
        }
    });
    const orderedPermissions = eregPermissions.sort(permissionSort);
    const permissionsToShow = canManageDoA ? orderedPermissions : lodash.filter(orderedPermissions, (permission) => (permission.feature !== features.DELEGATION));
    const data = permissionsToShow.map(eregPermission => {
        let permission = {};
        for (let role of permissionRoles) {
            permission[role.name] = role.permissions.some(rolePermission =>
                (rolePermission.action === eregPermission.action) &&
                (rolePermission.feature === eregPermission.feature)
            );
        }
        return {
            id: eregPermission.id,
            action: eregPermission.displayName,
            editable: eregPermission.editable,
            ...permission,
        };
    });

    const newState = lodash.clone(state);
    lodash.set(newState, 'me.institution.rolesPermissions', { columns, data, permissionRoles });
    lodash.set(newState, 'me.institution.eregPermissions', eregPermissions);
    lodash.set(newState, 'me.institution.loadingRolesPermissions', false);
    return newState;
}


export function loadingRolesPermissions(state, action) {
    if (!action || action.type !== LOADING_ROLE_PERMISSIONS) {
        return state;
    }
    const newState = lodash.clone(state);
    lodash.set(newState, 'me.institution.loadingRolesPermissions', true);
    return newState;
}


export default composeReducers(
    getRolesPermissions,
    loadingRolesPermissions,
);
